export default __webpack_public_path__ + "static/media/logo1.cd4bfc7c.png";